import { useEffect, useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { Text } from 'foundations-components/components/Text';
import OccurrencesTable from 'ContentComponents/components/cmv2/occurrences/OccurrencesTable';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const i18nKey = key => `ContentComponents.cmv2.fields.choice.reorder.${key}`;
const MODAL_OPEN_EVENT = 'FileManagerLib:Drawer:open';
const MODAL_CLOSE_EVENT = 'FileManagerLib:Drawer:close';

// Hack to make sure DnD still works in modal in Editors -
// Dispatching "open" event will block pointer events on the editor iframe
// while the modal is open so that DnD hover events are still triggered:
// https://git.hubteam.com/HubSpot/ContentEditorUI/blob/master/ContentEditorUI/static/js/components/app/AutoHidePreviewFrameWhenDragDropModalIsOpen.js
const dispatchModalEvent = isOpen => {
  document.dispatchEvent(new CustomEvent(isOpen ? MODAL_OPEN_EVENT : MODAL_CLOSE_EVENT));
};
const ReorderChoicesButton = ({
  field,
  fieldKey,
  onFieldChange,
  value
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const onIsOpenChange = _isOpen => {
    dispatchModalEvent(_isOpen);
    setIsOpen(_isOpen);
  };
  const [reorderedValue, setReorderedValue] = useState(value);
  useEffect(() => {
    setReorderedValue(value);
  }, [value]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [isOpen && /*#__PURE__*/_jsxs(Modal, {
      children: [/*#__PURE__*/_jsxs(DialogHeader, {
        children: [/*#__PURE__*/_jsx(Text, {
          as: "h2",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: i18nKey('modal.header')
          })
        }), /*#__PURE__*/_jsx(DialogCloseButton, {
          onClick: () => onIsOpenChange(false)
        })]
      }), /*#__PURE__*/_jsxs(DialogBody, {
        children: [/*#__PURE__*/_jsx(Text, {
          as: "p",
          marginBlockEnd: "-500",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: i18nKey('modal.description')
          })
        }), /*#__PURE__*/_jsx(OccurrencesTable, {
          field: field,
          fieldKey: fieldKey,
          flush: true,
          onFieldChange: (key, newValue) => setReorderedValue(newValue),
          reorderableOnly: true,
          values: reorderedValue
        })]
      }), /*#__PURE__*/_jsx(DialogFooter, {
        children: /*#__PURE__*/_jsx(Button, {
          onClick: () => {
            onFieldChange(reorderedValue);
            onIsOpenChange(false);
          },
          use: "primary",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: i18nKey('modal.confirm')
          })
        })
      })]
    }), /*#__PURE__*/_jsx(Button, {
      marginBlockStart: "100",
      paddingInlineStart: "0",
      onClick: () => onIsOpenChange(!isOpen),
      size: "extra-small",
      use: "transparent",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey('buttonLabel')
      })
    })]
  });
};
export default ReorderChoicesButton;